export const costFormatter = val => {
  const number = Number(val);

  if (isNaN(number))
    throw new Error(`Cannot format "${val}" as a cost, as it becomes NaN`);

  if (number === 0) return 'FREE';

  const preface = number < 0 ? '-$' : '$';

  return `${preface}${Math.abs(number).toFixed(2)}`;
};
